import React, { useState, useEffect, useContext } from 'react';
import { useParams } from 'react-router-dom';
import Loader from '../../lib/loader';
import { urlGenerator } from '../../lib/url';
import { getResource } from '../../services/api';
import { AppContext } from '../layout';
import {
    FacebookShareButton,
    WhatsappShareButton,
    TwitterShareButton,
    TelegramShareButton,
} from "react-share";

function ActualiteItem() {
    const [publication, setPublication] = useState(null);
    let { slug, parent } = useParams();
    const { appState, setAppState } = useContext(AppContext)


    useEffect(() => {
        getResource(`publications?slug=${slug}`).then(res => {
            setPublication(res.data['hydra:member'][0])
            setAppState({ ...appState, parent_menu: parent })
        })


    }, []);

    return (
        <div id="main">
            <div className="col-md-12">
                <div className="page-info">
                    <h2 className="text-center text-white">{publication && publication.titre}</h2>
                    <div className="bread-crumb">
                        <div className="container">
                            <span><a href="/">ACCUEIL</a> -</span>
                            <span><a href="/actualites">ACTUALITÉS</a> -</span>
                            <span>{publication && publication.titre}</span>
                        </div>
                    </div>
                </div>


            </div>
            <div className="container mb-3 mt-3">
                <div className="row" style={{ position: 'relative' }}>
                    <div className="col-sm-12 col-md-9 border-bottom-3">
                        <div className="card dgishadow">

                            <div className="d-flex justify-content-between bckColorDark p-3 text-white">
                                <div>
                                    Partagez sur:
                                    <FacebookShareButton className="secdText m-2" title={publication && publication.titre} url={`${process.env.REACT_APP_BASE_URL}/${`actualites/${publication && publication.slug}`}`}>
                                        <i
                                            className="fab fa-facebook"></i>
                                    </FacebookShareButton>
                                    <WhatsappShareButton className="secdText m-2" title={publication && publication.titre} url={`${process.env.REACT_APP_BASE_URL}/${`actualites/${publication && publication.slug}`}`}>
                                        <i
                                            className="fab fa-whatsapp"></i>
                                    </WhatsappShareButton>
                                    <TelegramShareButton className="secdText m-2" title={publication && publication.titre} url={`${process.env.REACT_APP_BASE_URL}/${`actualites/${publication && publication.slug}`}`}>
                                        <i
                                            className="fab fa-telegram"></i>
                                    </TelegramShareButton>
                                    <TwitterShareButton className="secdText m-2" title={publication && publication.titre} url={`${process.env.REACT_APP_BASE_URL}/${`actualites/${publication && publication.slug}`}`}>
                                        <i
                                            className="fab fa-twitter"></i>
                                    </TwitterShareButton>
                                </div>
                            </div>

                            {publication == null ? <Loader /> : publication && publication.media && <img src={`${process.env.REACT_APP_API_BASE_URL}/${publication.media.contentUrl}`} alt={publication.titre} style={{ height: '300px' }} className="img-fluid" />}

                            <div className="page-content " style={{ position: 'relative', paddingLeft: 11, paddingTop: 15, paddingRight: 15 }}
                                dangerouslySetInnerHTML={{ __html: `${publication && publication.contenuPublication}` }}
                            >

                            </div>


                        </div>
                    </div>

                    <div className="col-sm-12 col-md-3">
                        <div className="card dgishadow" style={{ position: 'relative', paddingTop: 11, paddingBottom: 7, paddingLeft: 11, zIndex: 3 }} >
                            <h5>Catégories</h5>
                            <div className="w-25 divider">
                                &nbsp;
                            </div>
                            <div className="list-group article-list">
                                <a href="/actualites" className="list-group-item list-group-item-action" aria-current="true">
                                    Activités du ministre
                                </a>
                                <a href="/communiques" className="list-group-item list-group-item-action">Communiqués</a>
                                {/* <a href="#" className="list-group-item list-group-item-action">TVA non déductible sur certains
                                biens et services</a>
                            <a href="#" className="list-group-item list-group-item-action">Charges déductibles ou non
                                déductible</a> */}

                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </div>
    )
}

export default ActualiteItem;